import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "retriesSection"];
  static values = {
    waitMinutesOptions: Array,
    sendViaOptions: Array,
  };

  connect() {
    // Check initial poll selection
    this.updateVisibility();
  }

  pollChanged(event) {
    this.updateVisibility();
  }

  updateVisibility() {
    if (!this.hasRetriesSectionTarget) return;

    // Prefer hidden input created by Semantic UI dropdown, fallback to native select
    const hiddenInput = this.element.querySelector(
      'input[type="hidden"][name*="[poll_id]"]'
    );
    const selectInput = this.element.querySelector('select[name*="[poll_id]"]');
    const source = hiddenInput || selectInput;
    if (!source) return;

    const pollValue = source.value;
    const hasPoll =
      pollValue &&
      pollValue !== "" &&
      pollValue !== "none" &&
      pollValue !== "0";

    if (hasPoll) {
      this.retriesSectionTarget.classList.remove("no-show");
    } else {
      this.retriesSectionTarget.classList.add("no-show");
    }
  }
}
